import React from 'react';
import Banner from './Banner';
import "./HomeScreen.css"
import Nav from './Nav';
import requests from './requests';
import Row from './Row';

function HomeScreen() {
  return <div className = "homescreen">
      <Nav/>
      
      <Banner />

      <Row 
         title = 'NETFLIX ORIGINALS'
         fetchUrl = {requests.fetchNetflixOriginals}
         isLargeRow  />
      <Row  title = 'Trending Now'
         fetchUrl = {requests.fetchTrending}
         />
      <Row  title = 'Comedy Movies'
         fetchUrl = {requests.fetchComedyMovies}
         />
      <Row  title = 'Horror Movies'
         fetchUrl = {requests.fetchHorrorMovies}
         />
      <Row  title = 'Romance Movies'
         fetchUrl = {requests.fetchRomanceMovies}
         />
      <Row  title = 'Documentaries'
         fetchUrl = {requests.fetchDocumentaries}
         />
     
  </div>;
}

export default HomeScreen;
